import { render, staticRenderFns } from "./Pallative.vue?vue&type=template&id=d1e2b97e"
import script from "./Pallative.vue?vue&type=script&lang=js"
export * from "./Pallative.vue?vue&type=script&lang=js"
import style0 from "./Pallative.vue?vue&type=style&index=0&id=d1e2b97e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports